/**
 * Created by henian.xu on 2020/3/15.
 *
 */

import { addScript, addStyle } from 'utils/index';

export async function loadAliplayer() {
  if (window.Aliplayer) return window.Aliplayer;
  await Promise.all([
    addScript('./js/libs/aliplayer/aliplayer-h5-min.js'),
    addStyle('./js/libs/aliplayer/aliplayer-min.css'),
  ]);
  const { Aliplayer } = window;
  return Aliplayer;
}
